import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Button, Container, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Loader, SectionHeader } from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  BookingContainer,
  BookingDetailsData,
  cancelBookingAsync,
  ClearContainerAsync,
  ClearContainerItem,
  removeFromBookingContainerAsync,
  RemoveFromBookingContainerItem,
  selectBasketBookingContainer,
  selectBookingDetailsLoadingStatus,
  setBasketContainer,
  setBookingContainer,
  setWebShopCustomerState,
  TravelAgencyAccountData,
  TravelAgencyData,
  WebShopCustomerItem,
} from './bookingsSlice';
import { LOADING_STATUS, LOCALES, ROLES } from '../../common/constants';
import { NewBookingModal } from './Components/NewBookingModal';
import { NewTravelAgencyBookingModal } from './Components/NewTravelAgencyBookingModal';
import { checkRole } from '../auth/authSlice';
import {
  BookingType,
  bookingTypeTranslations,
} from './Constants/BookingTypeEnum';
import { useLocale } from '../../locales/useLocale';

function NewContainerDetails() {
  const isValidNamePart = (value?: string): boolean => {
    if (value === null || value === undefined) return false;
    const trimmed = String(value).trim();
    if (trimmed.length === 0) return false;
    const lower = trimmed.toLowerCase();
    return lower !== 'null' && lower !== 'undefined' && lower !== 'none';
  };
  const { t } = useTranslation();
  const backLinkUrl = '/bookings/search-accommodations';
  const params = useParams();
  const dispatch = useAppDispatch();
  const isTravelAgencyUser = useAppSelector(checkRole([ROLES.TravelAgency]));
  // console.log(`On travel agency käyttäjä: ${isTravelAgencyUser}`);
  const state = useLocation();
  const basketContainer = useAppSelector(selectBasketBookingContainer);
  const bookingDetailsLoadingStatus = useAppSelector(
    selectBookingDetailsLoadingStatus,
  );
  const { currentLocale } = useLocale();
  const currentLanguage = currentLocale === LOCALES.Fi ? 'fi' : 'en';
  const [showEditBookingModal, setShowEditBookingModal] =
    useState<boolean>(false);

  const [editedBooking, setEditedBooking] = useState<BookingDetailsData>(null);
  const [webshopCustomer, setWebshopCustomer] =
    useState<WebShopCustomerItem>(null);
  const [bookingTypeParam, setBookingTypeParam] = useState<number>(null);
  const createEmptyTravelAgencyData = (): TravelAgencyAccountData => ({
    finalClientFirstName: '',
    finalClientLastName: '',
    finalClientCompany: '',
    finalClientStreetAddress: '',
    finalClientZipCode: '',
    finalClientCity: '',
    finalClientCountry: '',
    finalClientEmail: '',
    finalClientPhone: '',
    travelAgencyPhone: '',
    travelAgencyEmail: '',
  });
  const initialBookingContainer: BookingContainer = {
    id: '',
    bookingContainerStatus: 0,
    bookingResponses: [],
    advancePaid: false,
    acceptMarketing: false,
    acceptCancelInsuranceTerms: false,
    acceptBookingTerms: false,
    siteId: '',
    adults: 0,
    childs: 0,
    containerTotal: 0,
    containerTravelTotal: 0,
  };
  const history = useNavigate();
  function clearBasket() {
    const clearCommand = {
      bookingContainerId: basketContainer.id,
    } as ClearContainerItem;
    dispatch(ClearContainerAsync(clearCommand)).then(() => {
      dispatch(setBasketContainer(initialBookingContainer));
      history(`/bookings/search-accommodations`);
    });
  }
  useEffect(() => {
    if (basketContainer !== null && basketContainer !== undefined) {
      // if (
      //   basketContainer !== null &&
      //   basketContainer !== undefined &&
      //   basketContainer.bookingResponses &&
      //   basketContainer.bookingResponses.filter(b => b.isCancelled).length >=
      //     basketContainer.bookingResponses.length
      // ) {
      //   clearBasket();
      // }
      // setBasketContainer(basketContainer);
      // if (
      //   params.customerId !== undefined &&
      //   params.bookingId !== undefined &&
      //   basketContainer.bookingResponses.length > 0
      // ) {
      //   dispatch(setWebShopCustomerState(null));
      //   const edited = basketContainer.bookingResponses.find(
      //     item => item.id === params.bookingId,
      //   );
      //   if (isTravelAgencyUser) {
      //     const storedBooking = {
      //       ...edited,
      //       payerId: params.customerId,
      //       travelAgencyData: createEmptyTravelAgencyData(),
      //     };
      //     setEditedBooking(storedBooking);
      //   } else {
      //     const storedBooking = {
      //       ...edited,
      //       payerId: params.customerId,
      //     };
      //     setEditedBooking(storedBooking);
      //     if (
      //       state.state.additional &&
      //       basketContainer.bookingResponses.length > 0 &&
      //       storedBooking
      //     ) {
      //       setShowEditBookingModal(true);
      //     }
      //   }
      //   setRefreshBookingModal(true);
      //   setShowEditBookingModal(true);
      // } else if (
      //   state.state &&
      //   state.state.additional &&
      //   basketContainer.bookingResponses &&
      //   basketContainer.bookingResponses.length > 0
      // ) {
      //   setEditedBooking(basketContainer.bookingResponses[0]);
      //   setShowEditBookingModal(true);
      // } else {
      //   history(`/bookings/bookingcontainer/newContainer`);
      //   setShowEditBookingModal(false);
      // }
    }
  }, [basketContainer]);
  useEffect(() => {
    // console.log('backurl', state.state.backUrl);
  }, [basketContainer]);
  useEffect(() => {}, [webshopCustomer]);

  function removeFromBasket(removedItem) {
    const removeData = {
      bookingId: removedItem.id,
      bookingContainerId: basketContainer.id,
      orderItemId: '00000000-0000-0000-0000-000000000000',
    } as RemoveFromBookingContainerItem;

    dispatch(removeFromBookingContainerAsync(removeData)).then(res => {
      if (res.payload.isSuccess === true) {
        dispatch(setBasketContainer(res.payload.result));
        setEditedBooking(null);
        if (
          res.payload.result &&
          !res.payload.result.bookingResponses?.length
        ) {
          history(`/bookings/search-accommodations`);
        }
      }
    });
  }

  function editBooking(index): void {
    if (
      basketContainer.bookingResponses != null &&
      basketContainer.bookingResponses[index] != null
    ) {
      setEditedBooking(basketContainer.bookingResponses[index]);
      setShowEditBookingModal(true);
    }
  }

  function getAccommodationName(index) {
    const orderitems =
      basketContainer.bookingResponses[index].bookingOrderItems;
    let retitem = orderitems.filter(item => item.orderItemType === 0);
    if (retitem != null && retitem.length > 0) {
      return retitem[0].itemName;
    }
    retitem = orderitems.filter(item => item.orderItemType !== 0);
    if (retitem != null && retitem.length > 0) {
      return retitem[0].itemName;
    }

    return '';
  }

  function getAccommodationPrice(index) {
    if (
      index !== null &&
      basketContainer !== undefined &&
      basketContainer !== null &&
      basketContainer.bookingResponses !== undefined &&
      basketContainer.bookingResponses !== null &&
      basketContainer.bookingResponses.length > index &&
      isTravelAgencyUser
    ) {
      return basketContainer.bookingResponses[
        index
      ].travelAgencyNetPrice.toFixed(2);
    }
    if (
      index !== null &&
      basketContainer !== undefined &&
      basketContainer !== null &&
      basketContainer.bookingResponses !== undefined &&
      basketContainer.bookingResponses !== null &&
      basketContainer.bookingResponses.length > index &&
      !isTravelAgencyUser
    ) {
      return basketContainer.bookingResponses[index].netPrice.toFixed(2);
    }
    return '';
  }

  const generateItemKey = function (Index: number, Text: string) {
    return `${Index.toString()}-${encodeURI(Text.substring(0, 12))}`;
  };
  function getBookingTypeByName(name: string): BookingType | undefined {
    const bookingTypeNames = Object.keys(BookingType).filter(key =>
      Number.isNaN(Number(key)),
    );
    const foundType = bookingTypeNames[Number(name)];
    return foundType
      ? BookingType[foundType as keyof typeof BookingType]
      : undefined;
  }
  function getBookingTypeTranslation(
    bookingType: string,
    locale: 'en' | 'fi',
  ): string {
    const selector = getBookingTypeByName(bookingType);
    return bookingTypeTranslations[locale][selector] || 'Unknown';
  }

  function getBookingPayer(item): string {
    let retval = '';
    if (item != null && item.payerId !== null && item.payerId !== undefined) {
      if (item.payerFirstName != null) {
        retval = item.payerFirstName;
      }
      if (item.payerLastName != null) {
        retval = `${retval} ${item.payerLastName}`;
      }
    }
    return retval;
  }
  const bookingItems =
    basketContainer?.bookingResponses &&
    basketContainer?.bookingResponses.map((item, index) => (
      <React.Fragment key={generateItemKey(index, item.id.toString())}>
        <tr className="position-relative">
          <td>
            <div>
              {item?.bookingNumber ? `${item.bookingNumber} – ` : ''}
              {getAccommodationName(index)}
            </div>
            <div className="text-muted small mt-4">
              {item?.bookingType !== undefined && (
                <span className="me-8">
                  {t('bookingDetails:bookingInfo.bookingType')}:{' '}
                  {getBookingTypeTranslation(
                    item.bookingType.toString(),
                    currentLanguage,
                  )}
                </span>
              )}
              {t('bookingDetails:bookingInfo.customer.payer')}:{' '}
              {getBookingPayer(item)}
            </div>
          </td>
          <td>{getAccommodationPrice(index)}</td>
          <td style={{ width: 48 }}>
            <Button
              onClick={() => editBooking(index)}
              size="sm"
              variant="outline-blue"
              className="px-16"
            >
              {t('common:buttons.modify')}
            </Button>
          </td>
          <td style={{ width: 48 }}>
            <Button
              onClick={() => removeFromBasket(item)}
              size="sm"
              variant="outline-danger"
              className="px-16"
            >
              <span className="bi bi-trash-fill">
                <span className="visually-hidden">
                  {t('common:buttons.delete')}
                </span>
              </span>
            </Button>
          </td>
        </tr>
      </React.Fragment>
    ));
  return (
    <>
      <Helmet>
        <title>{t('containerDetails.title')}</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={
            state != null && state.state != null && state.state.backUrl
              ? `${state.state.backUrl}`
              : backLinkUrl
          }
          Breadcrumbs={[t('containerDetails:header.breadcrumb')]}
          Title={t('containerDetails:header.title')}
        />

        <Loader
          IsLoading={bookingDetailsLoadingStatus === LOADING_STATUS.LOADING}
        />
        <div className="d-flex mb-16">
          <h2 className="h5 h-md-4 flex-grow-1 me-16">
            {t('containerDetails:servicesInBasket')}
          </h2>
          {basketContainer?.bookingResponses &&
            basketContainer?.bookingResponses.length > 0 && (
              <Button
                onClick={() => clearBasket()}
                size="sm"
                variant="outline-danger"
                className="ma-auto"
              >
                <span>{t('containerDetails:emptyBasket')}</span>
              </Button>
            )}
        </div>
        <div className="table-responsive-lg mb-48">
          <Table>
            <thead>
              <tr>
                <th colSpan={4}>{t('containerDetails:items.property')}</th>
              </tr>
            </thead>
            <tbody>{bookingItems}</tbody>
          </Table>
        </div>
        {isTravelAgencyUser && (
          <NewTravelAgencyBookingModal
            editedBooking={editedBooking}
            webshopCustomer={webshopCustomer}
            setShowNewBookingModal={setShowEditBookingModal}
            showNewBookingModal={showEditBookingModal}
            setEditedBooking={setEditedBooking}
            setBookingContainer={setBookingContainer}
            setBasketContainer={setBasketContainer}
          />
        )}
        {!isTravelAgencyUser && (
          <NewBookingModal
            bookingTypeParam={bookingTypeParam}
            editedBooking={editedBooking}
            webshopCustomer={webshopCustomer}
            setShowNewBookingModal={setShowEditBookingModal}
            showNewBookingModal={showEditBookingModal}
            setEditedBooking={setEditedBooking}
            setBookingContainer={setBookingContainer}
            setBasketContainer={setBasketContainer}
          />
        )}
      </Container>
    </>
  );
}

export default NewContainerDetails;
